module.exports = __webpack_public_path__ + "img/capacitor-woah.abb62424.jpg";